import { useContext } from 'react';
import { DocumentSettingsContext } from '../../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { PageSetupView } from '../../DocumentSettings/DocumentDesignSettings/PageSetupView';
import MarginSettings from '../../DocumentSettings/DocumentDesignSettings/margin/MarginSettings';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { useEffectiveOrientation } from 'hooks/useEffectiveOrientation';
import { FeatureFlags } from 'utils/featureFlags';
import PageOrientationSelect from '../../DocumentSettings/PageOrientationSelect';
import PageSizeSelect from '../../DocumentSettings/PageSizeSelect';

export function PageSetupSettings() {
  const { documentSettings, updateBackgroundColor, updatePageOrientation, updatePageSize, commitBackgroundColor, captureDocumentSettings } =
    useContext(DocumentSettingsContext);
  const orientation = useEffectiveOrientation();
  const isPageSizeEnabled = useFeatureFlag([FeatureFlags.editorPageSize])[FeatureFlags.editorPageSize];

  return (
    <PageSetupView
      backgroundColor={documentSettings.backgroundColor}
      onColorChange={updateBackgroundColor}
      onOpen={captureDocumentSettings}
      onClose={(color) => commitBackgroundColor && commitBackgroundColor(color)}
      sizeSlot={isPageSizeEnabled ? <PageSizeSelect value={documentSettings.pageSize} onChange={updatePageSize} /> : undefined}
      orientationSlot={<PageOrientationSelect value={orientation} onChange={updatePageOrientation} />}
      marginsSlot={<MarginSettings />}
    />
  );
}
